export default {
  backButton: {
    id: 'customer_conversation_back_button',
    defaultMessage: 'Back',
  },
}
